import React from 'react' 


export const ImgLeft = ({style, path}) => {
  return (
    <img className={style} src={path} alt="" />
  )
}
